import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { SpedDocumentListRequest } from '@/core/domain/sped/sped-documents/sped-documents.types';
import { Col, Form, Row } from 'antd';
import SpedDocumentStatusSelect from '../../SpedDocumentStatusSelect';
import { useEffect } from 'react';

interface Props {
  values?: Partial<SpedDocumentListRequest>;
  onChange: (values: Partial<SpedDocumentListRequest>) => void;
}

export default function SpedDocumentListFilter(props: Props) {
  const [form] = Form.useForm<SpedDocumentListRequest>();

  useEffect(() => {
    if (props.values) {
      form.setFieldsValue(props.values);
    }
  }, [props.values]);

  return (
    <Form form={form} onValuesChange={(_, values) => props.onChange(values)}>
      <Row gutter={[16, 16]}>
        <Col span={24} sm={6}>
          <FloatingFormItem name="companyId" label="Empresa">
            <CompaniesInfiniteSelectField
              selectFirst={!props.values?.companyId}
              queryEnable
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={4}>
          <FloatingFormItem name="status" label="Status">
            <SpedDocumentStatusSelect allowClear />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
